import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-video-grid',
  templateUrl: './video-grid.component.html',
  styleUrls: ['./video-grid.component.scss'],
})
export class VideoGridComponent {
  
  // Input property to accept video data from parent component
  @Input() videos: { id: string, title: string, description: string }[] = [];

  cols: number;

  constructor() {
    this.setGridCols(window.innerWidth);
  }

  // Responsive grid columns based on window size
  setGridCols(windowWidth: number): void {
    if (windowWidth <= 600) {
      this.cols = 1;
    } else if (windowWidth <= 960) {
      this.cols = 2;
    } else if (windowWidth <= 1280) {
      this.cols = 3;
    } else {
      this.cols = 4;
    }
  }

  getThumbnailUrl(videoId: string): string {
    return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  }

}